import { useContext } from 'react'
import LogRocket from 'logrocket'
import { Flex, Button } from '@jisr-hr/design-system'
import { Typography } from '@jisr-hr/ds'
import classnames from 'classnames'
import { ReactComponent as ArrowRightIcon } from 'assets/figma-icons/arrow-right.svg'
import I18n from 'translations/i18n'
import { OnboardingContext } from '../../context'
import { CURRENT_STEP } from '../../Onboarding'
import { StepsTypes } from '../../types/onboardingTypes'
import styles from './styles.module.css'

function StepTemplate({
  children,
  goNextStep,
  goPreviousStep,
  nextStep,
  previousStep,
  fetching,
  disableNextBtn,
  nextBtnType = 'button',
  hideFooter,
  className,
}: StepsTypes): JSX.Element {
  const { org, setMainStep } = useContext(OnboardingContext)
  const goToNextStep = (): void => {
    goNextStep?.()
  }

  const handleGoPrevStep = (): void => {
    if (previousStep?.title) {
      return goPreviousStep?.()
    }
    localStorage.setItem(`${org.metadata.onboarding_steps.current_step}_step_${org.id}`, '0')
    return setMainStep(CURRENT_STEP[org.metadata.onboarding_steps.current_step])
  }

  return (
    <>
      <div className={classnames('scroll-y')}>
        <div className={classnames(styles.content, className)}>{children}</div>
      </div>

      {!hideFooter && (
        <Flex
          itemsCenter
          justifyBetween
          className={classnames(styles.footer)}
        >
          <Button
            className={styles.backButton}
            startIcon={<ArrowRightIcon className={styles.buttonIcon} />}
            label={
              <span className={styles.buttonText}>
                <Typography
                  variant="title-1"
                  style={{ color: 'var(--color-base-colors-black-1000)' }}
                  text={previousStep?.title ? I18n.t('back') : I18n.t('exit')}
                />

                <Typography
                  variant="subtitle-1"
                  style={{ color: 'var(--color-base-colors-black-1000)' }}
                  className={styles.nextPrevStepTitle}
                  text={I18n.t(previousStep?.title || '')}
                />
              </span>
            }
            onClick={(): void => {
              LogRocket?.track('click_previous_step', {
                step_from: previousStep?.title,
              })
              handleGoPrevStep()
            }}
          />
          <Button
            disabled={fetching || disableNextBtn}
            className={styles.nextButton}
            endIcon={<ArrowRightIcon className={styles.buttonIcon} />}
            label={
              <span className={styles.buttonText}>
                <Typography
                  variant="title-1"
                  style={{ color: 'var(--color-base-colors-white-1000)' }}
                  text={I18n.t('next_onboardin')}
                />

                <Typography
                  variant="subtitle-1"
                  style={{ color: 'var(--color-base-colors-white-1000)' }}
                  className={styles.nextPrevStepTitle}
                  text={I18n.t(nextStep?.title || '')}
                />
              </span>
            }
            onClick={(): void => {
              LogRocket?.track('click_next_step', {
                step_from: nextStep?.title,
              })
              goToNextStep()
            }}
            type={nextBtnType}
          />
        </Flex>
      )}
    </>
  )
}

export default StepTemplate
